import { OccupancyValue } from '../../../../../../generic/ui/Selectors/OccupancySelector'

export const EXPIRATION_FILTER = {
    ALL: 0,
    EXPIRED: 1,
    DAYS_TO_EXPIRATION: 2,
} as const

export type ExpirationFilter = typeof EXPIRATION_FILTER[keyof typeof EXPIRATION_FILTER]

export interface IExpirationReportForm {
    productId: number
    growerId: number
    location: string
    daysToExpiration: string
    warehouseId: number
    expirationFilter: ExpirationFilter
    occupancy: OccupancyValue
}